// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'grommet/components/Button';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';
import { loadSites } from '../../actions/actions';
import { getValuesFromParseClass } from '../../actions/Api';
import constants from '../../Constants';
class EditControls extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectOptions: []
    }

  }
  componentWillMount() {

    if (this.props.controlType == constants.TWIG_EDIT_CONTROLS.SENSOR_TYPE) {
      let selectOptions = []
      for (let key in this.props.selectedTwig.details.data) {
        selectOptions.push({
          value: key,
          label: this.props.selectedTwig.details.data[key].label
        })
      }
      this.setState({
        selectOptions: selectOptions
      })
    } else if (this.props.controlType == constants.TWIG_EDIT_CONTROLS.SELECT) {
      getValuesFromParseClass(this.props.parseClass, this.props.hasUser).then(response => {

        let selectOptions = []
        for (let i = 0; i < response.data.length; i++) {
          selectOptions.push({
            value: response.data[i],
            label: response.data[i]
          })
        }
        this.setState({
          selectOptions: selectOptions,
          value: selectOptions[0].value
        })
        this.props.isCreate ? this.props.controlValueChange({ key: this.props.controlKey }, response.data[0]) : ''
      }).catch(error => {
          // console.log('error::', error)
      });
    }
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {


  }



  render() {
    let controlType = this.props.controlType;
    let toRender = null;
    let controlInfo = {
      key: this.props.controlKey,
      controlType: controlType
    }
    switch (controlType) {
      case constants.TWIG_EDIT_CONTROLS.BOOLEAN:

        toRender = <CheckBox
          defaultChecked={this.props.value}
          onChange={this.props.controlValueChange.bind(this, controlInfo)}
          toggle={false}
          disabled={false}
          reverse={false} />

        break;
      case constants.TWIG_EDIT_CONTROLS.TEXT:
        toRender = <input name={this.props.name ? this.props.name : ''} className="maxwidth" type={constants.TWIG_EDIT_CONTROLS.TEXT} onChange={this.props.controlValueChange.bind(this, controlInfo)} value={this.props.value} />
        break;
      case constants.TWIG_EDIT_CONTROLS.NUMBER:
        toRender = <input className="maxwidth" type="text" onChange={this.props.controlValueChange.bind(this, controlInfo)} defaultValue={this.props.value} />
        break;
      case constants.TWIG_EDIT_CONTROLS.SELECT:
      case constants.TWIG_EDIT_CONTROLS.SENSOR_TYPE:
        toRender = <select className="maxwidth" name="" id="" defaultValue={this.props.value} value={this.props.value} onChange={this.props.controlValueChange.bind(this, controlInfo)}>
          {
            this.state.selectOptions.map((item, index) => {
              return <option key={index} value={item.value}>{item.label}</option>
            })
          }
        </select>;
        break;
      default:
        break;

    }

    return (
      <div className="item maxwidth">
        <div className="label inlineblock">{this.props.label}</div>
        <div className="control inlineblock">
          {toRender}
        </div>
      </div>
    );
  }

}

// let select = (state, props) => ({
//   twigsList: state.locationView.twigsList,
//   selectedTwig: state.locationView.selectedTwig,
//   selectedTwigIndex: state.locationView.selectedTwigIndex,
// });

export default EditControls;




// WEBPACK FOOTER //
// ./src/js/components/site/Controls.js